export default __webpack_public_path__ + "static/integrated-calendar-m-8e38b2234927fd36edf11cb2595da3ff.webp";